import React from 'react'

const isProduction = process.env.NODE_ENV === 'production'
export function isNotAcceptStyle(children) {
  const isFragment = children.type === React.Fragment
  if (!React.isValidElement(children) || isFragment) {
    if (isProduction) {
      return true
    } else {
      const type = Array.isArray(children)
        ? 'array'
        : isFragment
        ? 'React.Fragment'
        : typeof children
      throw Error(
        `'Margin' component's children of type: ${type} doesn't support 'style' prop. To fix this error wrap the children in a valid React element that support 'style' props e.g. div, span or CustomComponent`
      )
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/isAcceptStyle/index.js